import http from 'services/httpService';
import { IContactsResponse } from 'types/api-responses';
import { IApiRoutes } from 'types/api-routes';

export const getContactsData = (): Promise<IContactsResponse> => {
  return Promise.resolve(
    http.get<string>(
      `${process.env.REACT_APP_PORTFOLIO_API}/${IApiRoutes.Contacts}`
    )
  )
    .then((response) => {
      return {
        data: {
          contacts: response.data,
        },
      };
    })
    .catch((err) => err);
};
